import React, { useState, useRef } from 'react';
import { Home, BarChart2, PhoneCall, Lightbulb, Settings, Menu, X, LogOut, ListChecks, Sun, Moon } from 'lucide-react';
import logoImage from '../assets/HiveMind_Logo.png';

function Sidebar({ isOpen = false, onToggle, activeView, onNavigateToDashboard, onNavigateToApprovals, onNavigateToReports, onNavigateToSettings, onLogout, onThemeToggle, currentTheme = 'dark' }) {
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const sidebarRef = useRef(null);

    // Minimum swipe distance to trigger close
    const minSwipeDistance = 50;

    const onTouchStartHandler = (e) => {
        if (!isOpen) return;
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMoveHandler = (e) => {
        if (!isOpen) return;
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEndHandler = () => {
        if (!isOpen || !touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        
        if (isLeftSwipe && onToggle) {
            onToggle();
        }
        
        setTouchStart(null);
        setTouchEnd(null);
    };

    return (
        <>
            {/* Mobile Toggle Button */}
            <button
                className="sidebar-toggle-btn"
                onClick={onToggle}
                aria-label="Toggle menu"
            >
                {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Overlay/Backdrop */}
            {isOpen && (
                <div 
                    className="sidebar-overlay"
                    onClick={onToggle}
                    aria-hidden="true"
                />
            )}

            {/* Sidebar */}
            <aside 
                ref={sidebarRef}
                className={`sidebar-container glass-sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}
                onTouchStart={onTouchStartHandler}
                onTouchMove={onTouchMoveHandler}
                onTouchEnd={onTouchEndHandler}
            >
                <div className="sidebar-content">
                    {/* Logo */}
                    <div className="sidebar-logo">
                        <img src={logoImage} alt="Client Desk Logo" style={{ width: '100%', height: 'auto', maxWidth: '48px' }} />
                    </div>
                    
                    {/* Navigation */}
                    <nav className="sidebar-nav">
                        <div 
                            className={`sidebar-nav-item ${activeView === 'dashboard' ? 'active' : ''}`} 
                            title="Home"
                            onClick={() => {
                                if (onNavigateToDashboard) {
                                    onNavigateToDashboard();
                                }
                                // Close sidebar on mobile after navigation
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <Home size={24} />
                        </div>
                        <div 
                            className={`sidebar-nav-item ${activeView === 'approvals' ? 'active' : ''}`} 
                            title="Approvals"
                            onClick={() => {
                                if (onNavigateToApprovals) {
                                    onNavigateToApprovals();
                                }
                                // Close sidebar on mobile after navigation
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <ListChecks size={24} />
                        </div>
                        <div 
                            className={`sidebar-nav-item ${activeView === 'reports' ? 'active' : ''}`} 
                            title="My Reports"
                            onClick={() => {
                                if (onNavigateToReports) {
                                    onNavigateToReports();
                                }
                                // Close sidebar on mobile after navigation
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <BarChart2 size={24} />
                        </div>
                        <div 
                            className="sidebar-nav-item" 
                            title="Schedule Call"
                            onClick={() => {
                                alert('Coming Soon: Schedule a Call');
                                // Close sidebar on mobile after action
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <PhoneCall size={24} />
                        </div>
                        <div 
                            className="sidebar-nav-item" 
                            title="Insights"
                            onClick={() => {
                                alert('Coming Soon: Insights');
                                // Close sidebar on mobile after action
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <Lightbulb size={24} />
                        </div>
                        <div 
                            className={`sidebar-nav-item ${activeView === 'settings' ? 'active' : ''}`} 
                            title="Settings"
                            onClick={() => {
                                if (onNavigateToSettings) {
                                    onNavigateToSettings();
                                }
                                // Close sidebar on mobile after navigation
                                if (isOpen && onToggle) {
                                    onToggle();
                                }
                            }}
                        >
                            <Settings size={24} />
                        </div>
                    </nav>
                    
                    {/* Theme Toggle Button */}
                    <div 
                        className="sidebar-nav-item" 
                        title={currentTheme === 'dark' ? 'Switch to Light Theme' : 'Switch to Dark Theme'}
                        onClick={() => {
                            if (onThemeToggle) {
                                onThemeToggle();
                            }
                            // Close sidebar on mobile after toggle
                            if (isOpen && onToggle) {
                                onToggle();
                            }
                        }}
                    >
                        {currentTheme === 'dark' ? <Sun size={24} /> : <Moon size={24} />}
                    </div>
                    
                    {/* Logout Button */}
                    <div 
                        className="sidebar-nav-item sidebar-logout-item" 
                        title="Logout"
                        onClick={() => {
                            if (onLogout) {
                                onLogout();
                            }
                            // Close sidebar on mobile after logout
                            if (isOpen && onToggle) {
                                onToggle();
                            }
                        }}
                    >
                        <LogOut size={24} />
                    </div>
                </div>
            </aside>
        </>
    );
}

export default Sidebar;

